import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production' 
  ? '' // Bruker en relativ sti i produksjon
  : 'http://localhost:5000'; // Beholder den gamle for lokal utvikling

function NewsSection() {
  const [latestArticle, setLatestArticle] = useState(null);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    axios.get(`${API_URL}/api/articles`).then(res => {
      if (res.data.length > 0) {
        setLatestArticle(res.data[0]); // Henter den nyeste (første i listen)
      }
    });
    axios.get(`${API_URL}/api/content/hjem`).then(res => {
      const activeSetting = res.data.find(item => item.element_id === 'hjem_nyheter_aktiv');
      setIsActive(activeSetting?.value === 'true');
    });
  }, []);

  if (!isActive || !latestArticle) {
    return null; // Viser ingenting hvis deaktivert eller ingen artikler finnes
  }

  return (
    <section className="news-section-wrapper">
      <div className="card news-card">
        <h2>Nyheter</h2>
        <h3>{latestArticle.title}</h3>
        <p>{latestArticle.intro_text}</p>
        <div className="news-card-buttons">
          <Link to={`/nyheter/${latestArticle.slug}`} className="button">
            Les mer
          </Link>
          <Link to="/nyheter" className="button secondary-button">
            Vis alle nyheter
          </Link>
        </div>
      </div>
    </section>
  );
}

export default NewsSection;